import supabaseClient from '@/api/supabaseClient';
import {
  FunctionsHttpError,
  SupabaseClient,
} from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';
import { BackendSuccessResponse } from '@/types/response/BackendSuccessResponse';
import { queryClient } from '@/main.tsx';

type RejectDnaRefinementResponse = {
  rejected: boolean;
};

const useRejectDnaRefinement = () => {
  const client = supabaseClient;

  return useMutation({
    mutationFn: (refinementId: string) =>
      rejectDnaRefinement(client, refinementId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['refinements'],
      });
    },
  });
};

export default useRejectDnaRefinement;

async function rejectDnaRefinement(
  client: SupabaseClient,
  refinementId: string,
): Promise<
  BackendSuccessResponse<RejectDnaRefinementResponse>
> {
  const { data, error } = await client.functions.invoke(
    'reject_dna_refinement',
    {
      body: { refinement_id: refinementId },
    }
  );

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse =
      await error.context.json();

    throw new Error(errorResponse.errors.join(', '));
  }

  return data;
}